import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import CategoryEdit from "./CategoryEdit";
import Products from "../product/Products";
import { ICategory } from "../../../models/ICategory";

interface CategoryRightPanelProps {
    setErrorAlert: any;
    selectedCategory: ICategory | null;
}

export default function CategoryRightPanel(props: CategoryRightPanelProps) {

    return (
        <Tabs
            defaultActiveKey="category_edit"
            className="mb-3">
            <Tab eventKey="category_edit" title="Категория">
                <CategoryEdit setErrorAlert={props.setErrorAlert} category={props.selectedCategory}></CategoryEdit>
            </Tab>
            <Tab eventKey="Products" title="Оборудование">
                <Products setErrorAlert={props.setErrorAlert} category={props.selectedCategory}></Products>
            </Tab>
        </Tabs>
    )
}